import React from 'react'
import withParams from '../../../modules/router-manage/withParams'
import BannerListContainer from '../../templates/banner-list/BannerListContainer'
import Navbar from '../../templates/navbar/Navbar'
import TownHeader from '../../templates/navbar/TownHeader'
import BannerListActionPanel from '../../templates/banner-list/BannerListActionPanel'

const BannerListPage = props => (
  <div>
    <Navbar />
    <div className="container">
      <div className="section">
        <TownHeader />
        <BannerListActionPanel />
        <hr />
        <BannerListContainer {...props} />
      </div>
    </div>
  </div>
)

export default withParams(BannerListPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/BannerListPage.js